export default "__VITE_ASSET__BO$cR_p1__"